import { Account } from '../schema/accountSchema'
import { expandedAccounts } from './expandedClientList'
import { generatedAccounts } from './generatedAccounts'
export const hearst: Account = {
  id: 'acct-hearst',
  name: 'Hearst',
  logo_url: 'https://placehold.co/96x48?text=Hearst',
  industry: 'Media & Publishing',
  region: 'North America',
  health: 'Green',
  primary_owner: {
    id: 'u1',
    name: 'Olivia Park',
    role: 'Group Admin',
    email: 'olivia.park@quad.example',
    role_title: 'Group Admin',
    function: 'Executive',
    side: 'Quad',
  },
  products_services: ['Marketing Services', 'Digital Signage', 'Direct Mail'],
  bots: [
    {
      name: 'Hearst QuadChat',
      type: 'external',
      link: 'https://spaces.sprinklenet.com/chat?id=68f6655611ce1212673e66cd',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f6655611ce1212673e66cd/chat',
      embed_code:
        '<iframe src="https://spaces.sprinklenet.com/chat-bot?id=68f6655611ce1212673e66cd" style="position: fixed; bottom: 20px; right: 20px; width: 290px; height: 530px; border: 0; @media (min-width: 768px) { right: 56px; width: 350px; }"></iframe>',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f6655611ce1212673e66cd/chat',
      purpose:
        'Client-facing assistant for Hearst partners to access campaign materials and brand guidelines.',
      bound_spaces: [
        {
          id: 'space-hearst-partner',
          name: 'Hearst Partner Knowledge Space',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view: 'https://atlas.quad.example/hearst?view=partner',
      purpose:
        'Internal assistant for Quad team members to access Hearst account specs and operational guidelines.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
    {
      name: 'Esquire Style Guide',
      type: 'external',
      link: 'https://esquire.hearst.example/style-guide',
      embed_code:
        '<iframe src="https://esquire.hearst.example/style-guide?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/esquire-style/chat',
      purpose:
        'Consumer-facing AI style advisor for Esquire readers, providing personalized fashion and grooming recommendations.',
      bound_spaces: [
        {
          id: 'space-esquire-consumer',
          name: 'Esquire Consumer Experience',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'Bicycling Buyer Guide',
      type: 'external',
      link: 'https://bicycling.hearst.example/buyer-guide',
      embed_code:
        '<iframe src="https://bicycling.hearst.example/buyer-guide?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/bicycling-guide/chat',
      purpose:
        'Consumer-facing AI assistant helping cyclists find the perfect bike, gear, and accessories based on their needs and riding style.',
      bound_spaces: [
        {
          id: 'space-bicycling-consumer',
          name: 'Bicycling Consumer Experience',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'Cosmo Valentine',
      type: 'external',
      link: 'https://cosmopolitan.hearst.example/valentine',
      embed_code:
        '<iframe src="https://cosmopolitan.hearst.example/valentine?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/cosmo-valentine/chat',
      purpose:
        'Consumer-facing AI relationship advisor for Cosmopolitan readers, offering dating tips, gift ideas, and romantic advice.',
      bound_spaces: [
        {
          id: 'space-cosmo-consumer',
          name: 'Cosmo Consumer Experience',
          visibility: 'Partner',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-hearst-1',
      title: 'Brand Guidelines 2025',
      kind: 'PDF',
      url: 'https://docs.quad.example/hearst/brand',
      last_updated: '2025-10-20',
    },
    {
      id: 'a-hearst-2',
      title: 'Campaign Brief Q1',
      kind: 'Doc',
      url: 'https://docs.quad.example/hearst/campaign',
      last_updated: '2025-11-01',
    },
  ],
  kpis: { active_jobs: 9, open_quotes: 4, sla_alerts: 0 },
  last_sync: '2025-11-05T10:30:00Z',
  workstreams: [
    {
      name: 'Digital Campaign Management',
      ownerId: 'u1',
      status: 'Active',
      kpi: '15 active campaigns',
    },
    {
      name: 'Print Production',
      ownerId: 'u4',
      status: 'Active',
      kpi: '9 jobs in progress',
    },
    {
      name: 'Brand Compliance Review',
      ownerId: 'u1',
      status: 'Active',
      kpi: '98% approval rate',
    },
  ],
  escalation_contacts: [
    {
      name: 'Olivia Park',
      email: 'olivia.park@quad.example',
      role: 'Primary Escalation',
    },
    {
      name: 'Maya Singh',
      email: 'maya.singh@quad.example',
      role: 'Executive Sponsor',
    },
  ],
  footprint: [
    { product: 'Marketing Services', utilization: 85 },
    { product: 'Digital Signage', utilization: 65 },
    { product: 'Direct Mail', utilization: 45 },
  ],
}
export const kohls: Account = {
  id: 'acct-kohls',
  name: "Kohl's",
  logo_url: 'https://placehold.co/96x48?text=Kohls',
  industry: 'Retail',
  region: 'North America',
  health: 'Green',
  primary_owner: {
    id: 'u2',
    name: 'Merritt Lane',
    role: 'Account Admin',
    email: 'merritt.lane@quad.example',
    role_title: 'Account Admin',
    function: 'Operations',
    side: 'Quad',
  },
  products_services: ['Direct Mail', 'In-Store Marketing', 'Digital'],
  bots: [
    {
      name: "Kohl's Partner Portal",
      type: 'external',
      link: 'https://assist.quad.example/kohls',
      embed_code:
        '<iframe src="https://assist.quad.example/kohls?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/kohls-partner/chat',
      purpose:
        'Partner assistant for store marketing materials and campaign tracking.',
      bound_spaces: [
        {
          id: 'space-kohls-partner',
          name: "Kohl's Partner View",
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view: 'https://atlas.quad.example/kohls?view=partner',
      purpose: 'Internal support for print specs and logistics.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-kohls-1',
      title: 'Holiday Campaign 2025',
      kind: 'PDF',
      url: 'https://docs.quad.example/kohls/holiday',
      last_updated: '2025-10-12',
    },
  ],
  kpis: { active_jobs: 14, open_quotes: 6, sla_alerts: 0 },
  last_sync: '2025-11-05T09:15:00Z',
  workstreams: [
    {
      name: 'Seasonal Direct Mail',
      ownerId: 'u2',
      status: 'Active',
      kpi: '14 active jobs',
    },
    {
      name: 'In-Store Signage',
      ownerId: 'u2',
      status: 'Active',
      kpi: '200+ stores',
    },
  ],
  escalation_contacts: [
    {
      name: 'Merritt Lane',
      email: 'merritt.lane@quad.example',
      role: 'Primary Escalation',
    },
  ],
  footprint: [
    { product: 'Direct Mail', utilization: 90 },
    { product: 'In-Store Marketing', utilization: 75 },
    { product: 'Digital', utilization: 55 },
  ],
}
export const generalMills: Account = {
  id: 'acct-genmills',
  name: 'General Mills',
  logo_url: 'https://placehold.co/96x48?text=GenMills',
  industry: 'Consumer Goods',
  region: 'North America',
  health: 'Yellow',
  primary_owner: {
    id: 'u3',
    name: 'Ava Brooks',
    role: 'Account Member',
    email: 'ava.brooks@quad.example',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
  },
  products_services: ['Packaging', 'Marketing Services', 'Direct Mail'],
  bots: [
    {
      name: 'General Mills Partner Hub',
      type: 'external',
      link: 'https://assist.quad.example/general-mills',
      embed_code:
        '<iframe src="https://assist.quad.example/general-mills?embed=1" width="100%" height="640"></iframe>',
      api_snippet:
        'https://api.quad.example/chatbots/general-mills-partner/chat',
      purpose: 'Brand compliance and packaging spec queries.',
      bound_spaces: [
        {
          id: 'space-genmills-partner',
          name: 'General Mills Partner View',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view:
        'https://atlas.quad.example/general-mills?view=partner',
      purpose: 'Internal packaging rules and vendor coordination.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-genmills-1',
      title: 'Packaging Standards 2025',
      kind: 'PDF',
      url: 'https://docs.quad.example/genmills/packaging',
      last_updated: '2025-09-28',
    },
  ],
  kpis: { active_jobs: 11, open_quotes: 3, sla_alerts: 2 },
  last_sync: '2025-11-04T16:45:00Z',
  workstreams: [
    {
      name: 'Packaging Production',
      ownerId: 'u3',
      status: 'At Risk',
      kpi: '11 jobs, 2 delayed',
    },
    {
      name: 'Brand Compliance',
      ownerId: 'u3',
      status: 'Active',
      kpi: '95% approval rate',
    },
  ],
  escalation_contacts: [
    {
      name: 'Ava Brooks',
      email: 'ava.brooks@quad.example',
      role: 'Primary Escalation',
    },
    {
      name: 'Olivia Park',
      email: 'olivia.park@quad.example',
      role: 'Secondary Escalation',
    },
  ],
  footprint: [
    { product: 'Packaging', utilization: 80 },
    { product: 'Marketing Services', utilization: 60 },
    { product: 'Direct Mail', utilization: 40 },
  ],
}
export const discover: Account = {
  id: 'acct-discover',
  name: 'Discover',
  logo_url: 'https://placehold.co/96x48?text=Discover',
  industry: 'Financial Services',
  region: 'North America',
  health: 'Green',
  primary_owner: {
    id: 'u6',
    name: 'Maya Singh',
    role: 'Org Admin',
    email: 'maya.singh@quad.example',
    role_title: 'Org Admin',
    function: 'Executive',
    side: 'Quad',
  },
  products_services: ['Direct Mail', 'Marketing Services', 'Logistics'],
  bots: [
    {
      name: 'Discover Partner Assistant',
      type: 'external',
      link: 'https://assist.quad.example/discover',
      embed_code:
        '<iframe src="https://assist.quad.example/discover?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/discover-partner/chat',
      purpose: 'Campaign status and compliance documentation.',
      bound_spaces: [
        {
          id: 'space-discover-partner',
          name: 'Discover Partner View',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view:
        'https://atlas.quad.example/discover?view=partner',
      purpose: 'Financial compliance and postal regulations.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-discover-1',
      title: 'Compliance Guidelines',
      kind: 'PDF',
      url: 'https://docs.quad.example/discover/compliance',
      last_updated: '2025-10-30',
    },
  ],
  kpis: { active_jobs: 8, open_quotes: 2, sla_alerts: 0 },
  last_sync: '2025-11-05T11:00:00Z',
  workstreams: [
    {
      name: 'Compliance Review',
      ownerId: 'u6',
      status: 'Active',
      kpi: '100% compliant',
    },
    {
      name: 'Campaign Execution',
      ownerId: 'u6',
      status: 'Active',
      kpi: '8 active jobs',
    },
  ],
  escalation_contacts: [
    {
      name: 'Maya Singh',
      email: 'maya.singh@quad.example',
      role: 'Primary Escalation',
    },
  ],
  footprint: [
    { product: 'Direct Mail', utilization: 70 },
    { product: 'Marketing Services', utilization: 65 },
    { product: 'Logistics', utilization: 50 },
  ],
}
export const hilton: Account = {
  id: 'acct-hilton',
  name: 'Hilton',
  logo_url: 'https://placehold.co/96x48?text=Hilton',
  industry: 'Hospitality',
  region: 'Global',
  health: 'Green',
  primary_owner: {
    id: 'u4',
    name: 'Liam Chen',
    role: 'Account Member',
    email: 'liam.chen@quad.example',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
  },
  products_services: ['In-Store Marketing', 'Digital Signage', 'Direct Mail'],
  bots: [
    {
      name: 'Hilton Partner Portal',
      type: 'external',
      link: 'https://assist.quad.example/hilton',
      embed_code:
        '<iframe src="https://assist.quad.example/hilton?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/hilton-partner/chat',
      purpose: 'Property signage and promotional materials.',
      bound_spaces: [
        {
          id: 'space-hilton-partner',
          name: 'Hilton Partner View',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view: 'https://atlas.quad.example/hilton?view=partner',
      purpose: 'Internal production schedules and vendor specs.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-hilton-1',
      title: 'Brand Standards 2025',
      kind: 'PDF',
      url: 'https://docs.quad.example/hilton/brand',
      last_updated: '2025-10-18',
    },
  ],
  kpis: { active_jobs: 6, open_quotes: 1, sla_alerts: 0 },
  last_sync: '2025-11-05T08:30:00Z',
  workstreams: [
    {
      name: 'Property Signage',
      ownerId: 'u4',
      status: 'Active',
      kpi: '500+ properties',
    },
    {
      name: 'Promotional Materials',
      ownerId: 'u4',
      status: 'Active',
      kpi: '6 active campaigns',
    },
  ],
  escalation_contacts: [
    {
      name: 'Liam Chen',
      email: 'liam.chen@quad.example',
      role: 'Primary Escalation',
    },
  ],
  footprint: [
    { product: 'In-Store Marketing', utilization: 85 },
    { product: 'Digital Signage', utilization: 70 },
    { product: 'Direct Mail', utilization: 35 },
  ],
}
export const cvs: Account = {
  id: 'acct-cvs',
  name: 'CVS Health',
  logo_url: 'https://placehold.co/96x48?text=CVS',
  industry: 'Healthcare & Pharmacy',
  region: 'North America',
  health: 'Yellow',
  primary_owner: {
    id: 'u5',
    name: 'Noah Patel',
    role: 'Account Member',
    email: 'noah.patel@quad.example',
    role_title: 'Account Member',
    function: 'Operations',
    side: 'Quad',
  },
  products_services: ['Direct Mail', 'In-Store Marketing', 'Logistics'],
  bots: [
    {
      name: 'CVS Partner Hub',
      type: 'external',
      link: 'https://assist.quad.example/cvs',
      embed_code:
        '<iframe src="https://assist.quad.example/cvs?embed=1" width="100%" height="640"></iframe>',
      api_snippet: 'https://api.quad.example/chatbots/cvs-partner/chat',
      purpose: 'Weekly circular updates and pharmacy compliance.',
      bound_spaces: [
        {
          id: 'space-cvs-partner',
          name: 'CVS Partner View',
          visibility: 'Partner',
        },
      ],
    },
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      deep_link_partner_view: 'https://atlas.quad.example/cvs?view=partner',
      purpose: 'Internal distribution and postal drop schedules.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-cvs-1',
      title: 'Circular Template 2025',
      kind: 'Doc',
      url: 'https://docs.quad.example/cvs/circular',
      last_updated: '2025-10-25',
    },
  ],
  kpis: { active_jobs: 13, open_quotes: 5, sla_alerts: 1 },
  last_sync: '2025-11-04T14:20:00Z',
  workstreams: [
    {
      name: 'Weekly Circulars',
      ownerId: 'u5',
      status: 'Active',
      kpi: '52 circulars/year',
    },
    {
      name: 'Pharmacy Compliance',
      ownerId: 'u5',
      status: 'Paused',
      kpi: 'Under review',
    },
  ],
  escalation_contacts: [
    {
      name: 'Noah Patel',
      email: 'noah.patel@quad.example',
      role: 'Primary Escalation',
    },
  ],
  footprint: [
    { product: 'Direct Mail', utilization: 75 },
    { product: 'In-Store Marketing', utilization: 60 },
    { product: 'Logistics', utilization: 55 },
  ],
}
export const quadInternal: Account = {
  id: 'acct-quad-internal',
  name: 'Quad Internal',
  logo_url: 'https://placehold.co/96x48?text=Quad',
  industry: 'Internal Operations',
  region: 'Global',
  health: 'Green',
  primary_owner: {
    id: 'u6',
    name: 'Maya Singh',
    role: 'Org Admin',
    email: 'maya.singh@quad.example',
    role_title: 'Org Admin',
    function: 'Executive',
    side: 'Quad',
  },
  products_services: [
    'Knowledge Management',
    'Training',
    'Process Documentation',
  ],
  bots: [
    {
      name: 'QuadChat',
      type: 'internal',
      link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
      api_endpoint:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      api_snippet:
        'https://spaces.sprinklenet.com/api/chatbots/68f2b29111ce1212673e5d87/chat',
      purpose:
        'Central knowledge base for all Quad employees covering processes, policies, and best practices.',
      bound_spaces: [
        {
          id: 'space-quad-internal',
          name: 'Quad Internal Knowledge Space',
          visibility: 'Internal',
        },
      ],
    },
  ],
  people: [],
  client_contacts: [],
  quad_team: [],
  assets: [
    {
      id: 'a-quad-1',
      title: 'Employee Handbook 2025',
      kind: 'PDF',
      url: 'https://docs.quad.example/internal/handbook',
      last_updated: '2025-11-01',
    },
    {
      id: 'a-quad-2',
      title: 'Process Documentation',
      kind: 'Doc',
      url: 'https://docs.quad.example/internal/processes',
      last_updated: '2025-10-28',
    },
  ],
  kpis: { active_jobs: 0, open_quotes: 0, sla_alerts: 0 },
  last_sync: '2025-11-05T12:00:00Z',
}
export const fullClientList: Account[] = [
  hearst,
  kohls,
  generalMills,
  discover,
  hilton,
  cvs,
  quadInternal,
  ...expandedAccounts,
  ...generatedAccounts,
]
